import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
ReactDOM.render(React.createElement(App, null), document.getElementById('root'));
